import Vue from 'vue';
import VueResource from 'vue-resource';
import { Auth } from 'aws-amplify';

Vue.use(VueResource);

// if the config file has a typo, you'll get weird errors here :(
const ENDPOINT = `${process.env.API_ENDPOINT}api/v1/`;

/** --------------------
 *
 *    Helper functions
 *
 * --------------------- */

const getRequest = (url) => Auth.currentSession().then(session => session.getIdToken().getJwtToken()).then(token =>Vue.http
  .get(`${ENDPOINT}${url}`, { headers: { Authorization: `Bearer ${token}` } })
  .then(res => res.json()));

const postRequest = (url, body) => Auth.currentSession().then(session => session.getIdToken().getJwtToken()).then(token => Vue.http.post(`${ENDPOINT}${url}`, body, {
  headers: { Authorization: `Bearer ${token}` }
}).then(res => res.json()));

const putRequest = (url, body) => Auth.currentSession().then(session => session.getIdToken().getJwtToken()).then(token => Vue.http.put(`${ENDPOINT}${url}`, body, {
  headers: { Authorization: `Bearer ${token}` }
}).then(res => res.json()));

const deleteRequest = (url) => Auth.currentSession().then(session => session.getIdToken().getJwtToken()).then(token => Vue.http.delete(`${ENDPOINT}${url}`, {
  headers: { Authorization: `Bearer ${token}` }
}).then(res => res.json()));

const postAndGetFile = (url, body) => Auth.currentSession().then(session => session.getIdToken().getJwtToken()).then(token => Vue.http.post(`${ENDPOINT}${url}`, body, {
  responseType: 'arraybuffer',
  headers: { Authorization: `Bearer ${token}`, accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
}));

const getScores = (searchBody) => postRequest(`reporting/survey-run-scores`, searchBody);

const getElementScores = (element, searchBody) => postRequest(`reporting/elements/${encodeURI(element)}/scores`, searchBody);

const getElementNames = () => getRequest(`reporting/elements`);

const getComments = (surveyRunIds, dimensionData) => postRequest(`survey-runs/${surveyRunIds.length > 1 ? 'multiple' : surveyRunIds[0]}/comments/analyze?surveyRunId=${surveyRunIds.length > 1 ? JSON.stringify(surveyRunIds) : ''}`, dimensionData);

export {
  getScores, 
  getElementNames,
  getElementScores,
  getComments
};



// WEBPACK FOOTER //
// ./src/services/Reporting.js